module.exports = __webpack_public_path__ + "img/arrow.b1471745.svg";